import useSWR from 'swr';
import { ApplicationError } from '@/src/shared/errors';
import { DGetSelfMedicationConversation } from '../data/dtos/conversation';
import { selfMedicationChatService } from '../services/self-medication';

export function useSelfMedicationConversation({
  userId,
}: Nullable<DGetSelfMedicationConversation>) {
  const execute = async () => {
    try {
      return await selfMedicationChatService.getUserConversation({
        userId: userId!,
      });
    } catch (error) {
      if (
        error instanceof ApplicationError &&
        error.message === 'CONVERSATION_NOT_FOUND'
      ) {
        return null;
      }
      throw error;
    }
  };

  const fetchKey = userId ? ['get-self-medication-conversation', userId] : null;
  const { mutate, data, isLoading, error } = useSWR(fetchKey, execute);

  return {
    mutate,
    data,
    error,
    isLoading,
  };
}
